import { render, staticRenderFns } from "./two-factor-authen.vue?vue&type=template&id=4e899008"
import script from "./two-factor-authen.vue?vue&type=script&lang=js"
export * from "./two-factor-authen.vue?vue&type=script&lang=js"
import style0 from "./two-factor-authen.vue?vue&type=style&index=0&id=4e899008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports